export default "../css/6ae79f83102ed7467a57eb4ec3002701.ttf";